import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useCampaignId } from "../hooks/useCampaignId";
import { Link } from "react-router-dom";

type EventRow = {
  id: string;
  title: string;
  location: string | null;
  start_at: string;
};

export default function Events() {
  // 🔵 Use global campaign from top bar
  const campaignId = useCampaignId();

  const [rows, setRows] = useState<EventRow[]>([]);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!campaignId) return;
    (async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, title, location, start_at")
        .eq("campaign_id", campaignId)
        .order("start_at", { ascending: true });
      if (error) setErr(error.message);
      else setRows((data ?? []) as EventRow[]);
    })();
  }, [campaignId]);

  async function createEvent() {
    setErr(null); setMsg(null);
    if (!campaignId || !title || !date || !time) {
      setErr("Title, date and time are required.");
      return;
    }
    const start_at = new Date(`${date}T${time}:00`);
    const payload = {
      campaign_id: campaignId,
      title,
      location: location || null,
      start_at: start_at.toISOString(),
    };

    const { error } = await supabase.from("events").insert(payload);
    if (error) { setErr(error.message); return; }

    setMsg("Event created.");
    setTitle(""); setLocation(""); setDate(""); setTime("");

    const { data: list } = await supabase
      .from("events")
      .select("id, title, location, start_at")
      .eq("campaign_id", campaignId)
      .order("start_at", { ascending: true });
    setRows((list ?? []) as EventRow[]);
  }

  return (
    <div style={{ padding: 16 }}>
      <h1 style={{ marginTop: 0 }}>Events</h1>

      {(msg || err) && (
        <div style={{
          marginBottom: 10, padding: "10px 12px", borderRadius: 10,
          background: msg ? "#ECFDF5" : "#FEF2F2",
          border: `1px solid ${msg ? "#A7F3D0" : "#FCA5A5"}`,
          color: msg ? "#065F46" : "#991B1B"
        }}>
          {msg || err}
        </div>
      )}

      {/* Campaign selector removed — uses top bar */}

      {/* Create new */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 12, marginBottom: 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Create Event</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 8 }}>
          <input placeholder="Title" value={title} onChange={e=>setTitle(e.target.value)} style={input} />
          <input placeholder="Location (optional)" value={location} onChange={e=>setLocation(e.target.value)} style={input} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <input type="date" value={date} onChange={e=>setDate(e.target.value)} style={input} />
            <input type="time" value={time} onChange={e=>setTime(e.target.value)} style={input} />
          </div>
          <button onClick={createEvent} style={primaryBtn} disabled={!campaignId}>Create</button>
        </div>
      </div>

      {/* List */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 12 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Upcoming / All Events</div>
        <div>
          {rows.map(r => (
            <Link key={r.id} to={`/events/${r.id}`} style={{
              display: "grid", gridTemplateColumns: "1fr auto", gap: 8,
              textDecoration: "none", color: "#111827", padding: "10px 8px",
              borderBottom: "1px solid #f1f5f9"
            }}>
              <div>
                <div style={{ fontWeight: 700 }}>{r.title}</div>
                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  {new Date(r.start_at).toLocaleString()} {r.location ? "• " + r.location : ""}
                </div>
              </div>
              <div style={{ alignSelf: "center" }}>›</div>
            </Link>
          ))}
          {rows.length === 0 && <div style={{ color: "#6b7280" }}>No events yet.</div>}
        </div>
      </div>
    </div>
  );
}

const input: React.CSSProperties = { padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb" };
const primaryBtn: React.CSSProperties = { padding: "10px 12px", borderRadius: 10, border: "none", background: "#0B2E5B", color: "#fff", fontWeight: 700, cursor: "pointer" };

